module.exports = __webpack_public_path__ + "static/media/64.da99c567.jpg";